import React from 'react';
import './Certificate.scss';

const Certificate = () => {
    const cert = [
        {
            id: 1,
            icon: 'Udemy-2021',
            image: '/assets/React.jpg',
            title: 'React-JS'
        },
        {
            id: 2,
            icon: 'FreeCodeCamp.org',
            image: './assets/DSA.PNG',
            title: 'Data Structure and Algorithms'
        },
    ]
    return (
        <div className="certificatePage">
            <div className="certificate-data">
            <div className="certificate">
            {
                cert.map((item)=>{
                    return <div className="certificato" key={item.id}>
                        <div className="image-data">
                            <img src={item.image} alt=""/>
                            <ul className="hover-items">
                                <li>
                                    {item.icon}
                                </li>
                            </ul>
                        </div>
                        <h5>
                            {item.title}
                        </h5>
                        
                    </div>
                })
            }
        </div>
            </div>
        </div>
    )
}

export default Certificate
